import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MDBModalRef, MDBModalService, ModalDirective } from 'angular-bootstrap-md';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { Config } from 'src/app/services/env.config';
import { ReportsService } from '../reports.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SuccessDialogComponent } from 'src/app/shared/success-dialog/success-dialog.component';

@Component({
  selector: 'app-rs-popup',
  templateUrl: './rs-popup.component.html',
  styleUrls: ['./rs-popup.component.scss']
})
export class RsPopupComponent implements OnInit {

  action = new Subject();
  message: string;
  data: any;
  brand : string = 'IDD_Brand';
  RssoLogin : boolean = false;
  SoLogin: boolean = false;
  AbmLogin: boolean = false;
  RbmLogin: boolean = false;
  NsmLogin: boolean = false;
  DealerLogin: boolean = false;

  xlname: any;
  xldata: any;
  @ViewChild('downloads', { static: true }) divClick: ElementRef;
  @ViewChild('exportModal', { static: true }) public downloadModalOnClick: ModalDirective;

   constructor(public reportsService: ReportsService, private sanitizer: DomSanitizer, private modalService: MDBModalService, private http: HttpClient) { 
     let data = JSON.parse(sessionStorage.getItem('userDetails'));
    if(data.DesigId == 4) {
      this.RssoLogin = true; 
    } else if(data.DesigId == 6) {
      this.SoLogin = true;
    } else if(data.DesigId == 7) {
      this.AbmLogin = true;
    } else if(data.DesigId == 8 ) {
      this.RbmLogin = true;
    } else if(data.DesigId == 9) {
      this.NsmLogin = true; 
    } else if(data.DesigId == 2 || data.DesigId == 3) {
      this.DealerLogin = true;
    }
  }


  ngOnInit() {
  this.getTableData();
  }
  close() {
    this.action.next('OK');
  }
  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
    })
  };

  tableData: any[]=[];
  getTableData()  {
   let  fromDate = moment(this.data.FromDate).format('DD-MM-YYYY');
    let toDate = moment(this.data.ToDate).format('DD-MM-YYYY');
    let data = JSON.parse(sessionStorage.getItem('user'));
    let user = { UserName : data.UserName , Region: this.data.Region, FromDate: fromDate, ToDate: toDate,RepType: this.brand, DealUserName: this.data.code}; 
    return this.http.post(Config.BaseEndpoint + '/GetOrderProcessed', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((data: any) => {
        if (data) {
        this.tableData = data;
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  successModalRef: MDBModalRef;
  waitingModalRef: MDBModalRef;
  export(){
      // this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
      //   data: {
      //     message: 'please wait'
      //   }
      // });
      let  fromDate = moment(this.data.FromDate).format('DD-MM-YYYY');
      let toDate = moment(this.data.ToDate).format('DD-MM-YYYY');
      let data = JSON.parse(sessionStorage.getItem('user'));
      let user = { UserName : data.UserName , Region: this.data.Region, FromDate: fromDate, ToDate: toDate,RepType: this.brand, DealUserName: this.data.code}; 
      return this.http
      .post(Config.BaseEndpoint + '/ExcelOrderProcessed', JSON.stringify(user)  , {  headers: new HttpHeaders({
        'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
      }) })
      .toPromise()
      .then((response: any) => {
        if (response.File) {
          // setTimeout(x => {
          //   this.waitingModalRef.hide()
          // }, 100)
          this.action.next('OK');
        this.xlname = response.FileName;
        let url = 'data:application/octet-stream;base64,'+  response.File;
        this.xldata =  this.sanitizer.bypassSecurityTrustResourceUrl(url);
        setTimeout(() => {
          this.divClick.nativeElement.click();
          }, 200);
          this.downloadModalOnClick.hide();
        }
        else {
          // setTimeout(x => {
          //   this.waitingModalRef.hide()
          // }, 100)
          this.action.next('OK');
          let message = "There is no file available for Export";
          this.successModalRef = this.modalService.show(SuccessDialogComponent, {
            data: {
              message: message,
              data: []
            }
          });
          this.successModalRef.content.action.subscribe(result => {
            if (result == 'OK') {
              this.successModalRef.hide();
            }
          })
         
        }
      })
      .catch((error) => {
        return Promise.reject(error);
      });

}

}
